import { useTranslation } from 'react-i18next'
import GenericInputField from '@/containers/SubscriptionFormPageNew/Components/Contact/Fields/Default/GenericInputField'
import ForceFieldButton from '../ForceFieldButton'
import usePhone, { type PhoneField } from './usePhone'

interface PhoneProps {
  field: PhoneField
  id?: string
  error?: string | null
  value: string | null
  label?: string
  isEditable?: boolean
  onBlur: (value: string | null) => void
  missing?: boolean
}

const Phone = ({ field, id, error = null, value, label, isEditable, onBlur, missing = false }: PhoneProps) => {
  const { t } = useTranslation()
  const { forceButtonHidden, caption, forcePhone, handleBlur } = usePhone({
    field,
    currentValue: value,
    error,
    onBlur,
  })

  return (
    <>
      <GenericInputField
        id={id}
        error={error}
        caption={caption}
        value={value}
        label={label}
        isEditable={isEditable}
        onBlur={handleBlur}
        missing={missing}
      />
      <ForceFieldButton
        hidden={forceButtonHidden}
        onForce={forcePhone}
        buttonText={t(`subscriptionForm:customer_module.${field}.forceButton`)}
      />
    </>
  )
}

export default Phone
